import { http } from '../utils/http'

// 查询
const searchAction = (params, page, size) => {
    const url = `/config/formulaInfo/page`
    return http.post(url, params, page, size)
};

// 新增 / 修改
const addAction = (params) => {
    const url = `/config/formulaInfo/save`
    return http.post(url, params)
};

// 删除
const delAction = (id) => {
    const url = `/config/formulaInfo/delete/${id}`
    return http.post(url)
};

// 获取单条数据
const getAction = (id) => {
    const url = `/config/formulaInfo/get/${id}`
    return http.post(url)
};

// 获取公式类型
const getFormulaTypeAction = () => {
    const url = `/config/formulaType/list`
    return http.post(url)
};

// 导出
const exportAction = (params) => {
    const url = `/config/formulaInfo/export`
    return http.post(url, params)
};


export default {
    searchAction,
    addAction,
    delAction,
    getAction,
    getFormulaTypeAction,
    exportAction
  }